module.exports = __webpack_public_path__ + "static/media/main_sp.559f79af.jpg";